import { IPropertyEditable } from "../../../../base/domain/system/edit";
import { TextAlignKinds } from "../../../../base/domain/drawing";
import { IRollSelectBehavior, TranscribeTargetKinds } from "../../../../documaker/domain/format/objects";
import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IRollObject } from "../objects";
import { IRollSelectBehaviorPropertyEditable } from "../properties";
import { AbstractSelectableObjectEditor } from "./AbstractSelectableObjectEditor";

export class RollObjectEditor extends AbstractSelectableObjectEditor<IRollObject> implements IRollSelectBehaviorPropertyEditable {
  constructor(source: IRollObject | RollObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
    this._inputRuleBehavior = this.createInputRuleBehaviorPropertyEditor();
    this._rollSelectBehavior = this.createPropertyEditor(s => s.rollSelectBehavior, (s, v) => s.rollSelectBehavior = v);
  }

  protected _rollSelectBehavior: IPropertyEditable<IRollSelectBehavior>;

  rollSelectBehavior(): IPropertyEditable<IRollSelectBehavior> {
    return this._rollSelectBehavior;
  }

  getTypeName(): string {
    return "クリック選択";
  }

  getSelectableAlignmentKinds(): TextAlignKinds[] {
    return this._specification.objects.roll.alignmentKinds;
  }

  getSelectableTranscribeTargets(): TranscribeTargetKinds[] {
    return this._specification.objects.roll.transcription.targets;
  }

  clone(): IFormatObjectEditable {
    return new RollObjectEditor(this);
  }
}
